import { useRouter } from 'next/router'
import { useSnapshot } from 'valtio'
import cn from 'classnames'
import Link from 'next/link'
import 'react-toastify/dist/ReactToastify.css'
import { type ReactElement } from 'react'
import { usdFormatter } from '../../../../../shared/utils/formattingUtils'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { APP_RECURRING_PAYMENTS_PATH } from '../../../../../pages/app/recurring-charges'
import SuccessCheck from '../../../../../shared/components/ui/icons/SuccessCheckIcon'
import JumpIcon from '../../../../../shared/components/ui/icons/JumpIcon'
import { recurringPaymentNewProxy } from '../recurringPaymentNewProxy'

export function Success (): ReactElement {
  const { form: { values } } = useSnapshot(recurringPaymentNewProxy)
  const router = useRouter()
  const { siteTheme } = useSnapshot(proxyGlobalAuth)
  return (
    <>
      <div className="w-full bg-white rounded shadow-lg p-4 md:mr-4">
        <h1 className="text-xl text-center">Charge Created</h1>
        <div className="flex justify-center my-8">
          <SuccessCheck />
        </div>
        <hr className="my-8" />
        <h2 className="text-center text-2xl opacity-80 my-8 font-semibold">
          {usdFormatter.format(parseFloat(values.amount as string))}
        </h2>
        <h3 className="text-center my-8">
          <span className="font-semibold">Invoice Number:&nbsp;</span>
          <span className="underline">{values.invoiceNumber as string}</span>
        </h3>

        <div className="flex justify-center">
          <a
            className={cn(
              siteTheme.buttonColors.classes,
              'flex justify-center text-white rounded-lg text-center py-4 px-12'
            )}
            style={{ width: '36rem' }}
            onClick={router.reload}
          >
            Create New Recurring Charge &nbsp;&nbsp;
            <JumpIcon />
          </a>
        </div>

        <div className="flex justify-center my-8">
          <Link href={APP_RECURRING_PAYMENTS_PATH}>
            <div
              className={cn(
                siteTheme.navigationLinkColors.classes,
                'flex justify-center rounded-lg bg-white text-center py-4 px-12 cursor-pointer'
              )}
            >
              View Recurring Charges
            </div>
          </Link>
        </div>
      </div>
    </>
  )
}
